import React, { useState } from "react";
import "./styles.css";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import EventsImg from "../../../../assets/images/events.jpg";
import useGetAllData from "../../../../hooks/useGetAllData";
import { ICategories } from "../../../../models/categories";

const SpotlightSection: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();

  function getSubstringAfterColon(str: string): string {
    const index = str.indexOf(":");
    if (index === -1) {
      return "";
    }
    return str.substring(index + 1);
  }

  const category_id = getSubstringAfterColon(location?.pathname);

  const { data: categories } = useGetAllData<ICategories[]>({
    queryKey: ["categories"],
    url: "categories",
    options: {
      enabled: !!category_id,
    },
  });

  return (
    <>
      <div className="spotlight_section w-full sm:min-h-[700px] min-h-[80vh] lg:px-20 sm:px-10 px-5">
        <video
          autoPlay
          muted
          loop
          className="background-video sm:pt-[100px] pt-20"
        >
          <source
            src={"http://api.udrc.uz/media/66c0864d15c0a_.mp4"}
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </div>

      <div className="container mx-auto px-5">
        <div className="grid grid-cols-12 gap-5 my-6">
          <div className="col-span-12">
            <h2 className="max-lg:text-base text-[22px] font-medium text-main_color mb-3">
              Markaz
            </h2>
            <h3 className="text-lg">
              <span className="font-semibold">
                {t("Tashkent Mediation Center (TMC/UDRC)")}
              </span>{" "}
              {t(
                "is a non-profit, non-governmental organization committed to fostering a modern culture of dispute resolution. The Center specializes in assisting individuals, business entities, and other stakeholders in resolving conflicts peacefully, lawfully, and constructively."
              )}
              <br />
              <br />
              {t(
                "The primary mission of TMC is to create a pathway for parties to reach mutually acceptable and sustainable agreements without resorting to court proceedings. The Center operates with a team of qualified mediators and arbitrators who approach each case in a professional, impartial, and systematic manner."
              )}
              <br />
              <br />
              {t(
                "In its activities, the Center relies on international best practices as well as national legislation. Its work is based on key principles such as impartiality and neutrality of the mediator or arbitrator, strict confidentiality of all information and procedures, voluntary participation of the parties, and efficiency in terms of time, cost, and emotional burden compared to court proceedings."
              )}
              <br />
              <br />
              {t(
                "The Tashkent Mediation Center provides services in various fields, including commercial and business disputes, labor and employment disagreements, family conflicts (including property division), as well as civil and other legal disputes."
              )}
              <br />
              <br />
              {t(
                "The Center creates a reliable and neutral environment in which each party can freely express its interests, engage in constructive dialogue, and work toward a fair and reasoned resolution. This approach not only resolves the immediate dispute but also helps to build long-term cooperation and mutual trust."
              )}
              <br />
              <br />
              {t(
                "In addition, the Center operates a Court of Domestic Arbitration. Decisions of this court are issued in accordance with the laws of the Republic of Uzbekistan, have the same legal force as court rulings, and are subject to mandatory enforcement by state authorities. This mechanism is especially beneficial for businesses, as it allows disputes to be resolved quickly and confidentially without disrupting business operations."
              )}
              <br />
              <br />
              {t(
                "The Tashkent Mediation Center is not merely a dispute resolution body but an important institution that contributes to the development of legal culture and promotes respectful, dialogue-based relationships in society. By applying modern approaches, engaging highly qualified professionals, and maintaining a client-oriented focus, the Center ensures that each case is handled with care and integrity. If you are looking to resolve your dispute quickly, fairly, professionally, and confidentially, TMC is your most reliable partner."
              )}
            </h3>
          </div>

          <div className="sm:col-span-4 col-span-12 text-center">
            <Link to={"/sample-paragraphs/:238"}>
              <img
                className="w-full h-[250px] text-center block mx-auto mb-3"
                src={
                  "https://static.wixstatic.com/media/1cd646_ae7f0376474742e4ac9a0dee2f3f5a5d~mv2_d_2508_1672_s_2.jpg/v1/fill/w_640,h_426,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/1cd646_ae7f0376474742e4ac9a0dee2f3f5a5d~mv2_d_2508_1672_s_2.jpg"
                }
                alt="icon"
              />
              <p className="max-lg:text-base text-[22px] font-medium text-main_color">
                {t("Model clauses")}
              </p>
            </Link>
          </div>
          <div className="sm:col-span-4 col-span-12 text-center">
            <Link to={"/calculator"}>
              <img
                className="w-full h-[250px] text-center block mx-auto mb-5"
                src={
                  "https://media.geeksforgeeks.org/wp-content/uploads/20230219213349/calculator.jpg"
                }
                alt="icon"
              />
              <p className="max-lg:text-base text-[22px] font-medium text-main_color">
                {t("Calculator")}
              </p>
            </Link>
          </div>
          <div className="sm:col-span-4 col-span-12 text-center">
            <Link to={"/news-and-events/:213"}>
              <img
                className="w-full h-[250px] text-center block mx-auto mb-3"
                src={EventsImg}
                alt="icon"
              />
              <p className="max-lg:text-base text-[22px] font-medium text-main_color">
                {t("News")}
              </p>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default SpotlightSection;
